const INIT_FLAG = 'stgbIhcInit';
const MOBILE_CLASS = 'is-mobile';
const DESKTOP_CLASS = 'is-desktop';

const initColumns = (root: HTMLElement) => {
    if (root.dataset[INIT_FLAG] === 'true') return;

    const breakpoint = parseInt(root.dataset.stgbIhcBreakpoint || '700', 10);

    const apply = (width: number) => {
        const mobile = width < breakpoint;
        root.classList.toggle(MOBILE_CLASS, mobile);
        // is-desktop also cancels the pre-JS small-viewport stacking
        // fallback in _save.scss once the real measurement is in.
        root.classList.toggle(DESKTOP_CLASS, !mobile);
    };

    if (typeof ResizeObserver !== 'undefined') {
        // Measure the block's own width (not the viewport) so the layout also
        // adapts when the block sits inside a narrow column or sidebar.
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                apply(entry.contentRect.width);
            }
        });
        observer.observe(root);
        // The observer's first callback is asynchronous; apply the current
        // width now so narrow screens never flash the desktop layout.
        apply(root.clientWidth);
    } else {
        const measure = () => apply(root.clientWidth);
        let resizeRaf = 0;
        window.addEventListener('resize', () => {
            if (resizeRaf) return;
            resizeRaf = window.requestAnimationFrame(() => {
                resizeRaf = 0;
                measure();
            });
        });
        measure();
    }

    root.dataset[INIT_FLAG] = 'true';
};

const initAll = () => {
    // The front-end script is also enqueued in the editor; skip it there so it
    // never fights with the React-rendered editor preview.
    if (document.body.classList.contains('wp-admin')) return;
    document.querySelectorAll<HTMLElement>('.stgb-image-hover-columns').forEach(initColumns);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}

// Mark this side-effect file as a module so its top-level constants are
// module-scoped (avoids a global-scope name clash with other blocks' react.ts).
export {};
